import React, { useState, useEffect, useRef } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import { appNotify } from 'store/actions';
import AutoComplete from 'components/underwrite/acquisition/import/importOpportunities/LocationVerification/AutoComplete';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  InputAdornment,
  TextField
} from '@material-ui/core';

const LocationVerificationSearchBox = ({ appNotify, searchWithPm, initialValue, pmSearchIsLoading }) => {
  const searchBox = useRef(null);
  const autoCompleteRef = useRef(null);
  const [place, setPlace] = useState(null);
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    if (inputValue !== initialValue) {
      setInputValue(initialValue);
    }

  }, [initialValue]);

  const onPlaceChanged = (e) => {
    const place = autoCompleteRef.current.getPlace();
    console.log(place)
    if (!place?.geometry) return; // User entered the name of a Place that was not suggested and pressed the Enter key, or the Place Details request failed.
    setPlace(place);
    setInputValue(place.formatted_address);
  }

  const onInputChange = e => {
    if (place) {
      setPlace(null);
    }
    setInputValue(e.target.value);
  }

  const getAddressComponent = (place, component) => {
    let components = place.address_components.filter(c => c.types.length > 0 && c.types[0] === component);
    if (components.length === 0) {
      return "";
    } else {
      if (component === "administrative_area_level_2" && components[0].short_name?.endsWith(" County")) {
        return components[0].short_name.substring(0, components[0].short_name.length - " County".length);
      }
      return components[0].short_name;
    }
  }

  const handleSearch = e => {
    if (!place.address_components) {
      console.log('no address_components found for place')
      appNotify('No address components found for place', 'warning');
      return;
    }
    if (place.types.includes('street_address') || place.types.includes('premise')) {
      const street = getAddressComponent(place, 'street_number') + ' ' + getAddressComponent(place, 'route');
      const zipCode = getAddressComponent(place, 'postal_code');
      const city = getAddressComponent(place, 'locality');
      const state = getAddressComponent(place, 'administrative_area_level_1');
      searchWithPm({
        referenceId: 0,
        street,
        zipCode,
        city,
        state
      });
      setPlace(null);
    } else {
      console.log('place is not a street address')
      appNotify('Selected place is not a street address', 'warning');
    }
  }

  return (
    <div data-standalone-searchbox="">
      <AutoComplete
        ref={autoCompleteRef}
        onPlaceChanged={onPlaceChanged}
        options={{
          types: ['address']
        }}
      >
        <TextField
          inputRef={searchBox}
          autoComplete='off'
          onChange={onInputChange}
          type="text"
          placeholder="Enter an address"
          variant='outlined'
          size='small'
          style={{
            width: `600px`,
          }}
          InputProps={{
            startAdornment:
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
          }}
          inputProps={{
            style: { paddingTop: 8.5, paddingBottom: 8.5 }
          }}
          // defaultValue={value}
          value={inputValue}
          disabled={pmSearchIsLoading}
        />
      </AutoComplete>
      <Button
        variant="outlined"
        color="primary"
        disabled={!place}
        onClick={handleSearch}
        style={{ marginLeft: 8 }}
      >Search</Button>
    </div>
  )
};

const styles = theme => ({
});

const mapDispatch = {
  appNotify
}

export default compose(
  withStyles(styles),
  connect(null, mapDispatch)
)(LocationVerificationSearchBox);